import { localizePath, stripLocalePrefix } from "@/lib/localeRoutes";

export const MUGLA_DESTINATIONS = [
  { slug: "bodrum" },
  { slug: "marmaris" },
  { slug: "fethiye" },
  { slug: "oludeniz" },
  { slug: "icmeler" },
  { slug: "gocek" },
  { slug: "dalyan" },
  { slug: "yalikavak" },
] as const;

export type MuglaDestinationSlug = (typeof MUGLA_DESTINATIONS)[number]["slug"];

const DESTINATION_SLUGS = new Set<string>(
  MUGLA_DESTINATIONS.map(({ slug }) => slug),
);

export function muglaHubPath(locale: string): string {
  return localizePath("/locations/mugla", locale);
}

export function muglaDestinationPath(
  slug: MuglaDestinationSlug,
  locale: string,
): string {
  return localizePath(`/locations/mugla/${slug}`, locale);
}

export function resolveMuglaDestination(
  pathname: string,
): MuglaDestinationSlug | null {
  const segments = stripLocalePrefix(pathname).split("/").filter(Boolean);
  if (
    segments.length !== 3 ||
    segments[0] !== "locations" ||
    segments[1] !== "mugla" ||
    !DESTINATION_SLUGS.has(segments[2])
  ) {
    return null;
  }
  return segments[2] as MuglaDestinationSlug;
}
